import { isHexDark } from "../../../../../../Utils/HelperFunction/HelperFunction";

// Utility to compute a lighter hover color (default 20% lighter)
export const lightenColor = (color: string, percent: number) => {
  const hex = color?.replace("#", "");
  if (!hex) return color;
  const full =
    hex.length === 3
      ? hex
          .split("")
          .map((c) => c + c)
          .join("")
      : hex;
  if (full.length !== 6) return color;
  const r = parseInt(full.slice(0, 2), 16);
  const g = parseInt(full.slice(2, 4), 16);
  const b = parseInt(full.slice(4, 6), 16);
  const lr = Math.min(255, Math.floor(r + (255 - r) * (percent / 100)));
  const lg = Math.min(255, Math.floor(g + (255 - g) * (percent / 100)));
  const lb = Math.min(255, Math.floor(b + (255 - b) * (percent / 100)));
  return `#${lr.toString(16).padStart(2, "0")}${lg
    .toString(16)
    .padStart(2, "0")}${lb.toString(16).padStart(2, "0")}`;
};

export const getHoverColor = (
  secondaryColor?: string,
  primaryColor?: string,
  brandColor?: string,
  fallback = "#f5f5f5",
  lightenPercent = 20
) => {
  const base = (
    secondaryColor ||
    primaryColor ||
    brandColor ||
    fallback
  )
    .replace(/!important/gi, "")
    .trim();

  const normalized = base.toLowerCase();
  if (normalized.startsWith("#")) {
    if(isHexDark(base))
    return lightenColor(base, lightenPercent);
    else
      return darkenColor(base, 10)
  }

  // Non-hex values fallback to a light neutral
  return "#f5f5f7";
};

export const darkenColor = (color: string, percent: number) => {
  const hex = color?.replace("#", "");
  if (!hex) return color;

  const full =
    hex.length === 3
      ? hex
          .split("")
          .map((c) => c + c)
          .join("")
      : hex;

  if (full.length !== 6) return color;

  const r = parseInt(full.slice(0, 2), 16);
  const g = parseInt(full.slice(2, 4), 16);
  const b = parseInt(full.slice(4, 6), 16);

  const dr = Math.max(0, Math.floor(r * (1 - percent / 100)));
  const dg = Math.max(0, Math.floor(g * (1 - percent / 100)));
  const db = Math.max(0, Math.floor(b * (1 - percent / 100)));

  return `#${dr.toString(16).padStart(2, "0")}${dg
    .toString(16)
    .padStart(2, "0")}${db.toString(16).padStart(2, "0")}`;
};

